import React from 'react'
import { CheckCircleFilled, DollarOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import { useTranslation } from 'react-i18next'
import { formatMoney } from 'accounting-js'

import './styles.less'

const FORMAT_MONEY = {
  symbol: '$',
  precision: 2
}

const PotentialPayment = ({ payment, confirmPayment, potentialPaymentClass }) => {
  const { t } = useTranslation()
  const {
    currencyCode,
    total,
    details: { BASE, ON_TIME, ORDER_COMPLETED }
  } = payment

  const title = <b className='popover-payment-title'>{t('jobs.tasks.potential-payment.title')}</b>
  const getContent = (isConfirmPayment) => {
    const icon = isConfirmPayment ? <CheckCircleFilled /> : ''
    return (
      <div className='popover-confirm-payment-content'>
        <p>
          {icon} {t(`jobs.tasks.potential-payment.${isConfirmPayment ? 'total' : 'potential-base'}`)}:{' '}
          {formatMoney(total, FORMAT_MONEY)} {currencyCode}
        </p>
        <p>
          {icon} {t('jobs.tasks.potential-payment.base-payment')}: {formatMoney(BASE, FORMAT_MONEY)} {currencyCode}
        </p>
        {ORDER_COMPLETED ? (
          <p>
            {icon} {t('jobs.tasks.potential-payment.complete-order')}: + {formatMoney(ORDER_COMPLETED, FORMAT_MONEY)}{' '}
            {currencyCode}{' '}
          </p>
        ) : null}
        {ON_TIME ? (
          <p>
            {icon} {t('jobs.tasks.potential-payment.give-time')}: + {formatMoney(ON_TIME, FORMAT_MONEY)} {currencyCode}
          </p>
        ) : null}
      </div>
    )
  }

  return (
    <div className={potentialPaymentClass}>
      <Popover placement='bottom' title={title} content={getContent(confirmPayment)}>
        <div>
          <DollarOutlined />
        </div>
      </Popover>
    </div>
  )
}

export default PotentialPayment
